import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';

const DeleteReferralModal = ({ isOpen, onClose, onConfirm, referral, loading }) => {
  if (!isOpen || !referral) return null;

  return (
    <div className="modal-overlay" style={{ zIndex: 1002 }}>
      <div className="modal-container modal-animated">
        <div className="modal-header">
          <h2>Delete Referral</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p style={{ color: '#d32f2f', fontWeight: 'bold', marginBottom: '15px' }}>
            Are you sure you want to delete this referral? This action cannot be undone.
          </p>
          <div className="detail-row" style={{ marginBottom: '8px' }}>
            <span className="detail-label" style={{ fontWeight: 600 }}>Patient:</span>
            <span className="detail-value">{referral.patient?.name || 'Unknown Patient'}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label" style={{ fontWeight: 600 }}>Notes:</span>
            <div
              className="detail-value"
              style={{
                padding: '8px',
                background: '#f8f9fa',
                borderRadius: '4px',
                marginTop: '4px',
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word'
              }}
            >
              {referral.text || 'No notes'}
            </div>
          </div>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="admin-submit-button"
            onClick={onConfirm}
            disabled={loading}
            style={{ backgroundColor: '#dc3545' }}
          >
            {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Delete Referral'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteReferralModal;
